// The video editor (components/Editor), one file per area so its strings are
// written and reviewed in pieces: t('editor.rve.<area>.<key>')
import shell from './shell.es.js';
import text from './text.es.js';
import layers from './layers.es.js';
import timeline from './timeline.es.js';

export default { shell, text, layers, timeline };
